<template>
  <div class="p-home">
    <header>
      <h1 class="title">欢迎来到智适应教学平台</h1>
      <h2 class="subhead">
        人工智能Ai教学，实现规模化因材施教，有效提升教学质量，促进教育公平
      </h2>
    </header>
    <!-- 跳转卡片 -->
    <main>
      <!-- 班级管理 -->
      <div
        class="main-tab pointer intelligence-ducation"
        @click="getJumpLink(1)"
        :class="learningTeacher ? '' : 'disableClick'"
      >
        <h5>智适应学习-教师端</h5>
        <p>减负增效，个性化精准教学</p>
        <div class="shade" v-if="!learningTeacher">暂未开通</div>
      </div>

      <!-- 课堂管理 -->
      <div
        class="main-tab pointer class-control"
        @click="jumpClass"
        :class="courseTeacher || courseHeadmaster ? '' : 'disableClick'"
      >
        <h5>智适应学习-实时堂控</h5>
        <p>实现班课下的个性化教学</p>
        <div class="shade" v-if="!courseTeacher && !courseHeadmaster">
          暂未开通
        </div>
      </div>

      <!-- 备课中心 -->
      <div
        class="main-tab pointer prepare-lessons"
        @click="onRouteClick(1)"
        :class="lessonPreparation ? '' : 'disableClick'"
      >
        <h5>备课中心</h5>
        <p>丰富资源，辅助老师备课，学生预习</p>
        <div class="shade" v-if="!lessonPreparation">暂未开通</div>
      </div>

      <!-- 练习中心 -->
      <div
        class="main-tab pointer exercise-center"
        @click="onRouteClick(2)"
        :class="exerciseCenter ? '' : 'disableClick'"
      >
        <h5>练习中心</h5>
        <p>同步教材资源，满足个性化练习</p>
        <div class="shade" v-if="!exerciseCenter">暂未开通</div>
      </div>
      <!-- 测评中心 -->
      <div
        class="main-tab pointer appraisal"
        @click="onRouteClick(0)"
        :class="precisionTest ? '' : 'disableClick'"
      >
        <h5>评测中心</h5>
        <p>多重场景应用，快速精准定位知识点掌握情况</p>
        <div class="shade" v-if="!precisionTest">暂未开通</div>
      </div>

      <!-- 学情分析 -->
      <div
        class="main-tab pointer class-analysis"
        @click="onRouteClick(3)"
        :class="classAnalysis ? '' : 'disableClick'"
      >
        <h5>学情分析</h5>
        <p>科学、多维度、多角度了解学情，助力精准教</p>
        <div class="shade" v-if="!classAnalysis">暂未开通</div>
      </div>
    </main>
    <!-- 产品价值 -->
    <section class="product-value mt-40">
      <h3>产品价值</h3>
      <ul>
        <li><img src="./images/administrator.png" alt="" /></li>
        <li><img src="./images/teacher.png" alt="" /></li>
        <li><img src="./images/student.png" alt="" /></li>
        <li><img src="./images/patriarch.png" alt="" /></li>
      </ul>
    </section>
    <!-- 产品特色 -->
    <section class="product-feature mt-40">
      <h3>产品特色</h3>
      <ul>
        <li
          v-for="(feature, index) in productFeature"
          :key="index"
          @click="onFeatureTabClick(index)"
          class="pointer"
        >
          <img :src="feature.imgUrl" alt="" />
          <p class="feature-name" :class="{ active: currentIndex === index }">
            {{ feature.name }}
          </p>
          <div
            class="sliding-block"
            :style="{
              visibility: currentIndex === index ? 'visible' : 'hidden',
            }"
          ></div>
        </li>
      </ul>
      <img :src="imgUrlList[currentIndex].img" alt="" class="feature-img" />
    </section>
    <!-- 选择学科弹出框 -->
    <div class="select-subject" v-if="showSelectMask && subjectList.length > 1">
      <div class="subject-box">
        <p class="subject-box__head">选择学科</p>
        <ul class="subject-box__body">
          <li
            v-for="(item, index) in subjectList"
            :key="index"
            @click="selectSubjects(item.zbSubjectId, index)"
            class="pointer"
            :class="{ active: currentSubjectId === index }"
          >
            {{ item.subjectName }}
          </li>
        </ul>
        <button class="subject-box__foot" @click="getJumpLink(3)"></button>
        <i @click="showSelectMask = false"></i>
      </div>
    </div>
    <!-- 视频播放弹出框 -->
    <div class="video-mask" v-if="showVideoMask">
      <div class="video-box">
        <Yplay :videoUrl="videoList[checkedVideo].videoUrl" />
        <i @click="showVideoMask = false"></i>
      </div>
    </div>
    <footer>
      <article class="qr-code" v-if="this.showCode">
        <img src="./images/qr_code.jpg" alt="" />
        <p>钉钉扫码进群 在线客服为您答疑</p>
      </article>
      <article class="learn-more" v-if="this.showService">
        <div @click="showVideo(0)">
          <img src="./images/video.png" alt="" />
          <p>产品介绍</p>
        </div>
        <div @click="showVideo(1)">
          <img src="./images/video.png" alt="" />
          <p>公司介绍</p>
        </div>
      </article>
      <div class="sidebar">
        <p
          class="scan-code"
          @mouseover="showCode = true"
          @mouseleave="showCode = false"
        ></p>
        <!-- <p
          class="service"
          @mouseover="showService = true"
          @mouseleave="mouseleave"
        ></p> -->
      </div>
    </footer>
  </div>
</template>

<script>
import { getSubjectList, getJumpLink } from '@/api/pt';
import { unlocking } from '@/utils/access-control';
import {
  LESSON_PREPARATION, PRECISION_TEST, LEARNING_TEACHER, COURSE_TEACHER, COURSE_HEADMASTER,
  EXERCISE_CENTER, CLASS_ANALYSIS,
} from '@/utils/access-code';
import Yplay from '@/components/y-player.vue';
import { openTab } from '@/utils';

const TEACHER_ROLE = 6008003;
const TEACHER_ERROR = -9999003;
export default {
  name: 'HomePage',
  components: {
    Yplay,
  },
  data() {
    const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
    return {
      showSelectMask: false,
      showVideoMask: false,
      showCode: false, // 二维码展示
      showService: false, // 联系我们展示
      currentIndex: 0,
      subjectList: [], // 当前老师所教授学科
      zbSubjectId: 0,
      currentSubjectId: -1,
      isTeacher: userInfo.position === TEACHER_ROLE,
      // eslint-disable-next-line global-require
      productFeature: [{ name: '智适应学习引擎', imgUrl: require('./images/engine.png') }, { name: '超纳米知识点拆分', imgUrl: require('./images/split_knowledge.png') }, { name: '打地基学习', imgUrl: require('./images/basics.png') }, { name: '海量个性化学习资源', imgUrl: require('./images/learning_resource.png') }],
      // eslint-disable-next-line global-require
      imgUrlList: [{ img: require('./images/engine_item.png') }, { img: require('./images/split_knowledge_item.png') }, { img: require('./images/basics_item.png') }, { img: require('./images/learning_resource_item.png') }],
      videoList: [
        { videoUrl: 'http://7niu-media1.classba.cn/hx_cz_wz_js_04_01.mp4' },
        { videoUrl: 'http://7niu-media1.classba.cn/hx_cz_wz_js_04_01.mp4' },
      ],
      checkedVideo: -1,
    };
  },
  computed: {
    lessonPreparation() { // 进入备课中心
      return unlocking(LESSON_PREPARATION);
    },
    precisionTest() { // 进入精准测评
      return unlocking(PRECISION_TEST);
    },
    learningTeacher() { // 进入智适应教师端
      return unlocking(LEARNING_TEACHER);
    },
    courseTeacher() { // 进入实时堂控系统—教师
      return unlocking(COURSE_TEACHER);
    },
    courseHeadmaster() { // 进入实时堂控系统—校长
      return unlocking(COURSE_HEADMASTER);
    },
    exerciseCenter() { // 进入练习中心
      return unlocking(EXERCISE_CENTER);
    },
    classAnalysis() { // 进入学情分析
      return unlocking(CLASS_ANALYSIS);
    },
  },
  methods: {
    onRouteClick(routeIndex) {
      const routeMap = {
        0: '/pt/test-center', // 测评中心
        1: '/pt/lesson-prepare', // 备课中心
        2: '/pt/exercise-center', // 练习中心
        3: '/pt/class-analysis', // 学情分析
      };
      this.$router.push({
        path: routeMap[routeIndex],
      });
    },
    // 获取user的教学学科
    async getSubjectList() {
      await getSubjectList().then((res) => {
        if (res.code === 200) {
          this.subjectList = res.data;
        }
      });
    },
    onFeatureTabClick(index) {
      this.currentIndex = index;
    },
    // 获取跳转URL
    getJumpLink(type) {
      getJumpLink({
        type,
        zbsubject_id: type === 3 ? this.zbSubjectId : 0,
      }).then((res) => {
        if (res.code === TEACHER_ERROR) {
          this.$message({
            message: '未找到您的教师账号，您暂时无法使用智适应教师端',
            type: 'error',
          });
          return;
        }
        if (res.code === 200) {
          let jumpUrl = res.data.url;
          if (type === 1) {
            jumpUrl = jumpUrl.replace('teacher', 'gxteacher');
          }
          openTab(jumpUrl);
        } else {
          this.$message({
            message: res,
            type: 'error',
          });
        }
      });
    },
    jumpClass() {
      if (this.isTeacher) {
        if (this.subjectList.length > 1) {
          this.showSelectMask = true;
        } else {
          this.zbSubjectId = this.subjectList[0].zbSubjectId;
          this.getJumpLink(3);
        }
      } else {
        console.log('校长');
        const isProduction = !window.location.host.includes('dev');
        const url = isProduction
          ? 'https://pschool.songshuai.com/#/main/supervise'
          : 'https://dev-pschool.myyixue.com/#/main/supervise';
        window.top.location.href = url;
      }
    },
    // 弹出框选择学科
    selectSubjects(subjectId, index) {
      this.zbSubjectId = subjectId;
      this.currentSubjectId = index;
    },
    mouseleave() {
      setTimeout(() => {
        this.showService = false;
      }, 3000);
    },
    showVideo(type) {
      this.checkedVideo = type;
      this.showVideoMask = true;
    },
  },
  activated() {
    this.getSubjectList();
  },
};
</script>

<style lang="scss" scoped>
.p-home {
  width: 100%;
  min-height: 100%;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 120px;
  h3 {
    height: 50px;
    font-size: 24px;
    color: #111f2c;
    line-height: 50px;
    background: url("./images/blue_triangle.png") no-repeat left center;
    background-size: 25px 50px;
    padding-left: 44px;
  }
  header {
    box-sizing: border-box;
    height: 1.93rem;
    padding: 0.58rem 0.40rem;
    background: url("./images/banner_songshu.png") no-repeat;
    box-shadow: 0px 2px 0.16rem 0px rgba(220, 225, 236, 0.5);
    background-size: 100%;
    border-radius: 4px;
    .title {
      font-size: 0.34rem;
      font-weight: 600;
      color: #ffffff;
      line-height: 0.48rem;
      letter-spacing: 1px;
      text-shadow: 0px 2px 4px rgba(70, 121, 231, 0.87);
    }
    .subhead {
      font-size: 18px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 22px;
      text-shadow: 0px 2px 4px #4475e9;
      margin-top: 0.13rem;
    }
  }
  main {
    display: flex;
    // padding: 0 40px;
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin-top: 15px;
    .main-tab {
      width: 3.30rem;
      min-height: 1.68rem;
      // margin-left: 10px;
      margin-top: 25px;
      background: #ffffff;
      box-shadow: 2px 4px 8px 0px rgba(213, 223, 240, 0.5);
      border-radius: 19px;
      padding: 0.20rem 0.15rem 0 0.20rem;
      box-sizing: border-box;
      position: relative;
      h5 {
        font-size: 0.20rem;
        font-weight: 400;
        color: #111f2c;
      }
      p {
        font-size: 0.13rem;
        font-weight: 400;
        color: rgba(17, 31, 44, 0.6);
        margin-top: 0.16rem;
      }
      .right-turn {
        width: 24px;
        height: 24px;
        display: block;
        color: #80bcff;
        border-radius: 50%;
      }
      .shade {
        width: 100%;
        min-height: 1.68rem;
        height: 100%;
        border-radius: 19px;
        box-sizing: border-box;
        // padding: 0;
        padding-top: 5px;
        // text-indent: 1.50rem;
        text-align: right;
        padding-right: 0.2rem;
        // padding-left: 170px;
        position: absolute;
        top: 0px;
        right: 0.5px;
        background: #909090;
        opacity: 0.4;
        cursor: not-allowed;
        font-size: 0.13rem;
        color: #ffffff;
      }
      &::after {
        content: "";
        width: 0.40rem;
        height: 7px;
        // background: #ffc87a;
        border-radius: 5px;
        position: absolute;
        bottom: -3px;
        left: calc(50% - 20px);
      }
      &:hover {
        border: 2px solid rgba(35, 139, 255, 0.5);
        transform: scale(1.05, 1.05);
      }
    }
    .prepare-lessons {
      background: url("./images/prepare_lessons.png") no-repeat;
      background-size: cover;
      &::after {
        background: #ffc87a;
      }
    }
    .appraisal {
      background: url("./images/appraisal.png") no-repeat;
      background-size: cover;
      &::after {
        background: #80bcff;
      }
    }
    .intelligence-ducation {
      background: url("./images/intelligence_ducation.png") no-repeat;
      background-size: cover;
      &::after {
        background: #b8aaff;
      }
    }
    .class-control {
      background: url("./images/class_control.png") no-repeat;
      background-size: cover;
      &::after {
        background: #ffa985;
      }
    }
    .exercise-center {
      background: url("./images/exercise_center.png") no-repeat;
      background-size: cover;
      &::after {
        background: rgba(239, 147, 231, 1);
      }
    }
    .class-analysis {
      background: url("./images/class_analysis.png") no-repeat;
      background-size: cover;
      &::after {
        background: rgba(134, 233, 197, 1);
      }
    }
    .disableClick {
      pointer-events: none;
    }
  }
  .product-value {
    margin-top: 60px;
    ul {
      min-height: 400px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      li {
        margin-top: 32px;
        img {
          width: 483px;
          height: 144px;
        }
      }
    }
  }
  .product-feature {
    margin-top: 30px;
    ul {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      border-bottom: 1px solid #c5e1fc;
      padding-bottom: 20px;
      li {
        text-align: center;
        margin-top: 22px;
        position: relative;
        img {
          width: 83px;
          height: 70px;
        }
        .feature-name {
          font-size: 20px;
          color: #111f2c;
        }
        .active {
          color: #1989fa;
        }
      }
    }
    .sliding-block {
      width: 60px;
      height: 8px;
      background: #238bff;
      border-radius: 4px;
      display: inline-block;
      position: absolute;
      transform: translateX(-50%);
      bottom: -24px;
    }
  }
  .select-subject {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    .subject-box {
      padding: 30px 34px 63px;
      width: 527px;
      height: 367px;
      position: absolute;
      top: 60px;
      left: 50%;
      transform: translateX(-50%);
      background: url("./images/pop_up_back.png") no-repeat;
      background-size: contain;
      &__head {
        text-align: center;
        font-size: 24px;
        color: #000000;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          bottom: 0px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 16px;
          background: rgba(230, 162, 60, 0.2);
          border-radius: 7px;
        }
      }
      &__body {
        li {
          text-align: center;
          width: 110px;
          height: 40px;
          line-height: 40px;
          background: #ffffff;
          border-radius: 20px;
          border: 1px solid #1989fa;
          font-size: 16px;
          color: #1989fa;
          float: left;
          margin-left: 46px;
          margin-top: 24px;
        }
        .active {
          color: #fff;
          background: #1989fa;
        }
      }
      &__foot {
        margin: 258px auto;
        display: block;
        width: 218px;
        height: 44px;
        background: url("./images/pop_up_back(2).png") no-repeat;
        background-size: contain;
      }
      i {
        position: absolute;
        top: 36px;
        right: 36px;
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url("./images/turnoff.png") no-repeat;
        background-size: 14px 14px;
        cursor: pointer;
      }
    }
  }
  .video-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 998;
    .video-box {
      padding: 55px 34px 63px;
      width: 527px;
      height: 367px;
      position: absolute;
      top: 60px;
      left: 50%;
      transform: translateX(-50%);
      background: url("./images/pop_up_back.png") no-repeat;
      background-size: contain;
    }
    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      position: absolute;
      top: 20px;
      right: 26px;
      cursor: pointer;
      background: url("./images/turnoff.png") no-repeat;
      background-size: 14px 14px;
    }
  }
  footer {
    position: fixed;
    right: 2px;
    top: 70%;
    display: flex;
    justify-content: center;
    .sidebar {
      width: 48px;
      // height: 101px;
      height: 48px;
      background: rgba(159, 196, 235, 0.19);
      box-shadow: 0px 2px 4px 0px rgba(129, 172, 223, 0.4);
      border-radius: 8px;
      box-sizing: border-box;
      padding: 3px;
      // border-radius: 11px;
      // padding: 10px 2px;
      p {
        width: 42px;
        height: 42px;
        margin-top: 1px;
      }
      .scan-code {
        background: url("./images/contact_us.png") no-repeat;
        background-size: contain;
      }
      .service {
        background: url("./images/kown_us.png") no-repeat;
        background-size: contain;
      }
    }
    .qr-code {
      padding: 14px;
      box-sizing: border-box;
      width: 217px;
      height: 95px;
      background: url("./images/code_black.png") no-repeat;
      background-size: contain;
      display: flex;
      justify-content: space-evenly;
      img {
        width: 66px;
        height: 66px;
      }
      p {
        font-size: 13px;
        color: #ffffff;
        padding: 10px;
      }
    }
    .learn-more {
      display: flex;
      width: 292px;
      height: 118px;
      box-sizing: border-box;
      padding: 11px 15px;
      background: url("./images/service_black.png") no-repeat;
      background-size: contain;
      div {
        text-align: center;
        margin-right: 12px;
        img {
          width: 120px;
          height: 70px;
        }
        p {
          margin-top: 7px;
          font-size: 13px;
          color: #ffffff;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
